export default "__VITE_PUBLIC_ASSET__d79d6456__"